import { Component, OnInit } from '@angular/core';

import { Plano } from "../shared/plano.model";
import { planosModuleName } from "../shared/data.service";
import { PlanoApiService } from "../shared/plano-api.service";
import { PlanoNavigationService } from "../shared/plano-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { PlanoService } from "../shared/plano.service";
import { GroupByService } from "../../../shared/services/group-by.service";
import { ServicoApiService} from "../../servicos/shared/servico-api.service";
import { configuracaoModuleName } from "../../../shared/services/data.service";
import { manutencoesModuleName } from "../../shared/data.service";
import { ManutencaoService } from "../../shared/manutencao.service";

@Component({
    template: require('./plano-list.component.html'),
    styles: [require('./plano-list.component.css')]
})
export class PlanoListComponent implements OnInit {
    list: Plano[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    planosModuleName: any = planosModuleName;
    configuracaoModule: any = configuracaoModuleName;
    module: any = manutencoesModuleName;

    constructor(
        private _servicoApiService: ServicoApiService,
        private _planosApiService: PlanoApiService,
        private _planoService: PlanoService,
        private _planoNavigationService: PlanoNavigationService,
        private _utilService: UtilService,
        private _groupBy: GroupByService,
        private _manutencaoService: ManutencaoService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._planoService.clearSessionStorage();
        this._planoNavigationService.goToNew();
    }

    clickEdit(item: any) {
        this._planoService.clearSessionStorage();
        this._planoNavigationService.goToEdit(item.id);
    }

    clickGoToConfig() {
        this._manutencaoService.goToSetting();
    }

    clickDelete(item: Plano) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number, y: number, lenY: number;
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].Servicos) {
                        for (y = 0, lenY = Response[x].Servicos.length; y < lenY; y++) {
                            Response[x].Servicos[y].referenciaTempo = this._planoService.getReferenciaTempo(Response[x].Servicos[y].referenciaTempo);
                        }
                    } else {
                        Response[x].Servicos = [];
                    }
                }

                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._planosApiService.onGetAllPopulate(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._planosApiService.onDelete(item.id, onDone);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/planos/plano-list/plano-list.component.ts
 **/